const chapterMetadata = [
  {
    chapt_num: 1,
    chapt_name: "Prologue",
    subtitle: "Opening Scene with Oedipus and Priest (Stanzas 1-8)",
    hasAssessment: true
  },
  {
    chapt_num: 2,
    chapt_name: "Parodos",
    subtitle: "The Elders' Entry and First Choral Ode (Stanzas 1-6)"
  },
  {
    chapt_num: 3,
    chapt_name: "Episode 1",
    subtitle: "Oedipus Confronts Creon and Teiresias (Stanzas 1-15)",
    hasAssessment: true
  },
  {
    chapt_num: 4,
    chapt_name: "Stasimon 1",
    subtitle: "First Choral Interlude (Stanzas 1-7)"
  },
  {
    chapt_num: 5,
    chapt_name: "Episode 2",
    subtitle: "The Messenger Arrives with News (Stanzas 1-12)"
  },
  {
    chapt_num: 6,
    chapt_name: "Stasimon 2",
    subtitle: "Second Choral Interlude (Stanzas 1-8)"
  },
  {
    chapt_num: 7,
    chapt_name: "Episode 3",
    subtitle: "Jocasta's Revelation and Oedipus's Desperation (Stanzas 1-19)",
    hasAssessment: true
  },
  {
    chapt_num: 8,
    chapt_name: "Stasimon 3",
    subtitle: "Third Choral Interlude (Stanzas 1-5)",
    hasAssessment: true
  },
  {
    chapt_num: 9,
    chapt_name: "Exodus",
    subtitle: "The Final Confrontation and Reckoning (Stanzas 1-14)",
    hasAssessment: true
  }
];

export const chapters = chapterMetadata.map((chapter, index) => ({
  chapter_id: chapter.chapt_num,
  chapt_num: chapter.chapt_num,
  chapt_name: chapter.chapt_name,
  subtitle: chapter.subtitle,
  stanzaRange: chapter.subtitle,
  hasAssessment: chapter.hasAssessment || false,
  chunk: `chunk${String(index).padStart(2, '0')}`
}));

const getChapterByChunk = (chunk) => chapters.find((ch) => ch.chunk === chunk);

export const config = {
  id: "Oedipus",
  displayName: "Oedipus the King",
  author: "Sophocles",
  coverImage: "OedipusTheKing.png",
  route: "Oedipus",
  type: "drama",
  contentKey: "Oedipus",
  bookId: "oedipus",
  usesExternalLinks: false,

  getTitleForChunk: function(chunk) {
    const chapter = getChapterByChunk(chunk);
    return chapter ? chapter.chapt_name : "Oedipus the King";
  },

  getSubtitle: function(fragmentRange, _level, _showCefrLevel, chunk) {
    const chapter = getChapterByChunk(chunk);
    if (chapter?.subtitle) {
      return chapter.subtitle;
    }
    if (fragmentRange?.start && fragmentRange?.end) {
      return `Stanzas ${fragmentRange.start} - ${fragmentRange.end}`;
    }
    return "Oedipus the King";
  }
};

const book = { config, chapters };

export default book;
